import { render, staticRenderFns } from "./Contracts.vue?vue&type=template&id=661716f4&scoped=true&"
import script from "./Contracts.vue?vue&type=script&setup=true&lang=js&"
export * from "./Contracts.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661716f4",
  null
  
)

export default component.exports